import type { Verdict } from "@/mocks/types";
import { verdictMeta } from "@/mocks/types";

interface VerdictBadgeProps {
  verdict: Verdict;
  size?: "sm" | "md";
  className?: string;
}

export default function VerdictBadge({ verdict, size = "md", className = "" }: VerdictBadgeProps) {
  const meta = verdictMeta[verdict];
  const sizeCls =
    size === "sm"
      ? "px-2 py-0.5 text-[11px]"
      : "px-3 py-1 text-xs";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md font-medium tracking-wide whitespace-nowrap ${sizeCls} ${meta.tone} ${className}`}
    >
      <i className="ri-shield-check-line text-[13px]" aria-hidden="true"></i>
      {meta.label}
    </span>
  );
}